// src/services/upload.ts
import api from '../lib/api';

interface UploadResponse {
  url: string;
  publicId: string;
}

interface DocumentUploadResponse extends UploadResponse {
  originalName: string;
}

interface MultipleDocumentsResponse {
  files: DocumentUploadResponse[];
}

/**
 * Upload a profile photo
 */
export async function uploadProfilePhoto(file: File): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append('photo', file);

  const { data } = await api.post('/api/upload/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data;
}

/**
 * Upload a single document
 */
export async function uploadDocument(file: File): Promise<DocumentUploadResponse> {
  const formData = new FormData();
  formData.append('document', file);

  const { data } = await api.post('/api/upload/document', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data;
}

/**
 * Upload multiple documents
 */
export async function uploadMultipleDocuments(files: File[]): Promise<MultipleDocumentsResponse> {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('documents', file);
  });

  const { data } = await api.post('/api/upload/documents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data;
}

/**
 * Delete a file from Cloudinary
 */
export async function deleteFile(publicId: string): Promise<void> {
  await api.delete('/api/upload', {
    data: { publicId },
  });
}
